import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';

import { Stack, xcss } from '@atlaskit/primitives';

import { ErrorBoundary, Attribution } from '@confluence/error-boundary';

import { useElementVisibility, ELEMENTS } from '../hooks/useIsElementVisible';

import { IncomingLinksRow } from './IncomingLinksRow';
import { OutgoingLinksRow } from './OutgoingLinksRow';
import { JiraWorkItemsRow } from './JiraWorkItemsRow';
import { CustomContentRow } from './CustomContentRow';
import { AttachmentsRow } from './AttachmentsRow';

const i18n = defineMessages({
	connectionsSectionTitle: {
		id: 'details-panel.connections-section.title',
		defaultMessage: 'Connections',
		description:
			'Title for section containing metadata related to connections (links, files, custom content)',
	},
});

const connectionsSectionStyles = xcss({
	paddingLeft: 'space.300',
	paddingRight: 'space.300',
	marginTop: 'space.300',
});

export const ConnectionsSection = () => {
	const { isElementVisible } = useElementVisibility();

	return (
		<Stack testId="connections-section" xcss={connectionsSectionStyles}>
			<FormattedMessage {...i18n.connectionsSectionTitle} tagName="h4" />
			<ErrorBoundary attribution={Attribution.DISCO}>
				<Stack>
					<IncomingLinksRow />
					<OutgoingLinksRow />
					<AttachmentsRow />
					{isElementVisible(ELEMENTS.ROWS.CUSTOM_CONTENT) && <CustomContentRow />}
					<JiraWorkItemsRow />
				</Stack>
			</ErrorBoundary>
		</Stack>
	);
};
